exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toastContainer-root-sDt {\n    position: fixed;\n    display: grid;\n    grid-row-gap: 1rem;\n\n    /* Necessary to display over page contents */\n    z-index: 6;\n\n    /* Show toasts on bottom of screen */\n    bottom: 0px;\n    margin-bottom: 1rem;\n\n    /* Display in center */\n    min-width: 100%;\n}\n\n/* On desktop, display on right */\n@media (min-width: 1024px) {\n    .toastContainer-root-sDt {\n        right: 2rem;\n        min-width: auto;\n    }\n}\n", ""]);

// Exports
exports.locals = {
	"root": "toastContainer-root-sDt toastContainer-root-sDt"
};